import { ValidateInputDayService } from './validate-input-day.service';
import { inject, Injectable } from '@angular/core';
import { EventNeo, EventsNeo } from '@fichaje/interfaces/ficha.interface';
import { HelperTimeService } from '@common/services/helper-time.service';
import { HelperService } from '@common/services/helper.service';
import { EventNeoBuild, FichaSettings } from '@fichaje/interfaces/ficha-event.interface';
import { FichaEventBuildService } from './ficha-event-build.service';
import { UserLogged } from '@fichaje/interfaces/userLogged.interface';

@Injectable({
  providedIn: 'root'
})
export class FichaBuildService {
  private readonly helpData =       inject(HelperService);
  private readonly helpTime =       inject(HelperTimeService);
  private readonly validateInputDayService = inject(ValidateInputDayService);

  private readonly fichaEventBuild =  inject(FichaEventBuildService)


  validateDayStringISO(stringDayISO:string):string|undefined{
    // Validacion del formato fecha de stringDayISO, retorna undefined si no es valida
    const validStringDayISO = this.validateInputDayService.validateDayStringISO(stringDayISO);
    if(validStringDayISO !== stringDayISO)
      return undefined
    return validStringDayISO
  }

  //? ### 1) - build SETTINGS (& activate HEADER) #############################
  buildInitialFichaSettings(
    stringDaysISO:string,
    userLogged:UserLogged,
    isStation:boolean,
    readOnly:boolean
  ):FichaSettings {
    const stringDayISOToday = this.helpTime.dateToStringDayISO(new Date());
    const dateFromRoute =     new Date(stringDaysISO);
    const dateToday =         new Date(stringDayISOToday);

    const isToday = stringDaysISO == stringDayISOToday ? 'today' : undefined;
    const isPast = dateFromRoute < dateToday ? 'past' : undefined;

    const settings:FichaSettings = {
      whenIsIt: isPast ?? isToday ?? 'future',
      stringDayPretty: this.helpTime.ISO8601toLocalTimePretty(stringDaysISO, 'dd/mm/yyyy')??'No Date',
      stringDayISO: this.helpTime.dateToStringDayISO(dateFromRoute),
      // kpiColors: { good:'#2a951a', bad:'#EE6E6C', none:'transparent' },
      // kpiColors: { good:'#2a951a', bad:'#EE6E6C', none:'#999' },
      kpiColors: { good:'#2a951a', bad:'#EE6E6C', none:undefined },
      isStation: isStation,  //! falta a source
      readOnly: readOnly, //! falta a JSON source
      userLogged: userLogged
    }
    return settings
  }
  buildSettings(initialSettings?:FichaSettings, eventsResponse?:EventsNeo){
    if (initialSettings && eventsResponse) {
      const metaDatum = eventsResponse.meta
      const capabilities = metaDatum.capabilities;
      initialSettings.meta = {
        jornadaAnterior:          metaDatum.previous_work_day ?? undefined,
        eventoAnteriorSinFichaje: metaDatum.previous_work_day_without_clocking,
        metaV2:                   metaDatum.meta_v2,
      }
      initialSettings.capabilities = capabilities;
      initialSettings.workerCurrent = eventsResponse.meta.worker_current
    }
    return initialSettings;
  }

  //? ### 4) - build 'eventsComplete$' = eventsResponse$ ###########################
  buildEventsBuild( eventsResponse?:EventsNeo ){
    // console.log('xXx - en buildEventsBuild - EventsNeo', eventsResponse)
    if(!eventsResponse) return undefined
    const metaNeo = eventsResponse.meta
    const eventNeoArr:EventNeo[] = [...eventsResponse.data];

    if ( !(eventNeoArr && metaNeo) ) return undefined;

    // agrupa las pausas y permisos de meta segun eventoID
    const mappedLeaves = metaNeo.closed_leaves?.map((l:any) => ({...l, schedule_id: l.schedule_id ?? l.shedule_id})) ?? [];
    const permisosFinalizadosByScheduleId = this.helpData.arrToKeyBasedObj(mappedLeaves, 'schedule_id', 'id') ?? [];
    
    const mappedPauses = metaNeo.closed_pauses?.map((p:any) => ({...p, schedule_id: p.schedule_id ?? p.shedule_id})) ?? [];
    const pausasFinalizadasByScheduleId = this.helpData.arrToKeyBasedObj(mappedPauses, 'schedule_id', 'id') ?? [];

    let horasExtraActivaByScheduleId:any = {}
    if ( metaNeo.open_overtime ) {
      const ot = metaNeo.open_overtime
      const idtxt = 'id' + ot.schedule_id
      horasExtraActivaByScheduleId[idtxt] = ot;
    } else {
      horasExtraActivaByScheduleId = undefined;
    }
    //  = metaNeo.open_overtime ? {  } : undefined;
      // this.helpData.arrToKeyBasedObj(metaNeo.closed_pauses, 'schedule_id', 'id') ?? [];

    // asigna pausas y permisos a cada evento
    const eventsNeoBuild:EventNeoBuild[] =  eventNeoArr;
    for (const eventBuild of eventsNeoBuild) {
      // agregar extraEventData
      // eventBuild.extraEventData = this.setExtraEventData(eventBuild)
      // eventos finalizados
      if(permisosFinalizadosByScheduleId[ 'id' + eventBuild.id ])
        eventBuild.meta_closed_leaves = permisosFinalizadosByScheduleId[ 'id' + eventBuild.id ];
      if(pausasFinalizadasByScheduleId[ 'id' + eventBuild.id ])
        eventBuild.meta_closed_pause = pausasFinalizadasByScheduleId[ 'id' + eventBuild.id ];
      // horas extra abierta
      if(horasExtraActivaByScheduleId && horasExtraActivaByScheduleId[ 'id' + eventBuild.id ])
        eventBuild.meta_open_sub_event = horasExtraActivaByScheduleId[ 'id' + eventBuild.id ];
    }
    // console.log('xXx - en buildEventsBuild - END - eventsNeoBuild', eventsNeoBuild)
    // console.log('xXx - en buildEventsBuild - END - metaNeo', metaNeo)
    return eventsNeoBuild
  }

}
